import type React from 'react';
import type { ChatCompletionRequestMessageRole } from '@server/ai';

export type DataCardDetails = {
  type: CardTypes;
  text: string;
};

export enum CardTypes {
  TotalSupportRequests = 'Total Support Requests',
  ResolutionRate = 'Resolution Rate',
  AdminSupportRequests = 'Admin Support Requests',
  InProgress = 'In Progress',
}

export enum ConversationStatus {
  Ask_Admin = 'Asked for Admin help',
  Closed_By_Rep = 'Resolved by rep',
  Closed_By_Admin = 'Resolved by Admin',
  Open = 'Open',
}

export type AiAssistantFilters = {
  status?: string;
  startTime?: string;
  endTime?: string;
};

export type DataDisplayRow = {
  id: string;
  user: string;
  page: React.JSX.Element;
  status: React.JSX.Element;
  date: React.JSX.Element;
};

export type AiAssistantConversation = {
  id: string;
  username: string;
  updatedAt: string;
  status: ConversationStatus;
  pageUrl: string;
  messages?: AiMessage[];
};

export type AiMessage = {
  type: AiMessageType;
  text: string;
  sessionId: string | null;
  date: string;
  role: ChatCompletionRequestMessageRole;
};

export enum AiMessageType {
  PROMPT = 'PROMPT',
  SUGGESTION = 'SUGGESTION',
  NOTIFY = 'NOTIFY',
  AI_RESPONSE = 'AI_RESPONSE',
  AUTO_RESPONSE = 'AUTO_RESPONSE',
}
